export const selectExceptionally = <T>(item: T | undefined | null): T => {
    if (item !== undefined && item !== null) {
        return item;
    } else {
        console.log('Item was not yet initialized')
        throw new Error('Item was not yet initialized')
    }
}
